///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";
import { fetchUsers } from "./userManagementSlice";
import defaultUserManagementFilters from "../helpers/defaultUserManagementFilters";

export const initialState = defaultUserManagementFilters;
const userManagementFiltersSlice = createSlice({
  name: "userManagementFiltersSlice",
  initialState,
  reducers: {
    setUserManagementFilters: (state, { payload }) => {
      return payload;
    },
  },
});

export const { setUserManagementFilters } = userManagementFiltersSlice.actions;

export const updateUserManagementFilters = (payload) => (
  dispatch,
  getState
) => {
  const state = getState();
  let pageWasChanged =
    payload.filters.currentPage >= 0 &&
    payload.filters.currentPage !== state.userManagementFilters.currentPage;
  let updatedFilters;

  if (pageWasChanged) {
    updatedFilters = {
      ...state.userManagementFilters,
      currentPage:
        payload.filters.currentPage ?? state.userManagementFilters.currentPage,
    };
  } else {
    updatedFilters = {
      ...state.userManagementFilters,
      ...payload.filters,
      currentPage: 0,
    };
  }

  dispatch(setUserManagementFilters(updatedFilters));
  dispatch(fetchUsers(updatedFilters.currentPage));
};

export const resetUserManagementFilters = (payload) => (dispatch) => {
  dispatch(setUserManagementFilters(defaultUserManagementFilters));
  dispatch(fetchUsers(defaultUserManagementFilters.currentPage));
};

export const userManagementFiltersReducer = userManagementFiltersSlice.reducer;
